module.exports = __webpack_public_path__ + "media/images/arrow-next-e0d6c811db331eb9539370813424cd85.svg";